import { useQuery } from "@tanstack/react-query";
import { CampaignService } from "../services/BillingBrand.service";
import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";
import { BackednResponse, IGetFaectValue } from "@shared/lib/types";
import { BILLING_BRAND_FACETS_QUERY_KEY } from "../constants";
import { IBillingFacets } from "@shared/lib/types/brandBilling";

export function useGetBrandBillingFacets() {
  const { data, isLoading, isError, error, isFetching } = useQuery<
    BackednResponse<IBillingFacets>
  >({
    queryKey: BILLING_BRAND_FACETS_QUERY_KEY,
    queryFn: () => CampaignService.getBrandBillingFacets(),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    facets: data?.data,
    isError,
    isFetching: isLoading,
    isFetchingOrig: isFetching,
  };
}
